import "./BlogsLanding.scss";
import { Fragment } from "react";
import SideBlogCard from "./sideblogcard/SideBlogCard";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../../utils/apiData";

const BlogsLanding = ({recent, threeBlog }) => {


  const navigate = useNavigate();
  return (
    <section className="blog_landing">
      <div className="content_wrap p_top">
        <h2 className="wow fadeInUp">All Blogs</h2>

        {threeBlog?.length > 2 && <div className="blogs_bigrid">
          <div
            className="big_blog"
            onClick={() => navigate(`/blog/${recent.slug}`)}
          >
            <div className="img_wrap">
              <img src={`${baseUrl}/${recent?.image}`} alt="blog" />
            </div>
            <div className="text">
              <p className="t-12 wow fadeInUp">
                {recent?.subtitle || "-"}
              </p>
              <h3 className="wow fadeInUp" data-wow-delay="0.1s">
                {recent?.name || "-"}
              </h3>
              <p className="t-16 wow fadeInUp" data-wow-delay="0.2s">
                {recent?.small_description || "-"}
              </p>
            </div>
          </div>
          <div className="blog_list">
            {threeBlog?.length > 0 ? (
              threeBlog?.slice(0, 3)?.map((data, k) => {
                return (
                  <Fragment key={data._id}>
                    <SideBlogCard {...data} k={k} />
                  </Fragment>
                );
              })
            ) : (
              <p className="text-center">Data not found...</p>
            )}
          </div>
        </div>}
      </div>
    </section>
  );
};

export default BlogsLanding;
